import type { BackendResponse } from '#open-fetch'
import theme from './theme'

type CustomAppConfig = {
  auth: {
    // List of layouts that are accessible ONLY by guests
    guestsLayouts: string[]

    // List of pages that are accessible ONLY by guests
    guestsPages: string[]

    // The path to redirect to after the user impersonates another user
    impersonateRedirectionUrl: (id: number) => Promise<string | undefined>

    // List of layouts that are protected by the auth module
    protectedLayouts: string[]

    // List of pages that are protected by the auth module
    protectedPages: string[]

    // The path to redirect to after the user logs in
    redirectToAfterLogin: (user: BackendResponse<'getApiAuthMe'>) => string

    // The path to redirect to if the user is not authenticated
    redirectToIfUnauthenticated: string

    // A dictionnary of functions with the user as parameter (for instance to sign out if the person is not logged in as an admin account)
    shouldRemainAuthFns: Record<string, (user: any) => boolean>
  }
  theme: {
    dark: {
      logo: string
    }
    light: {
      logo: string
    }
  }
  ui: Record<string, any>
}

export default defineAppConfig<CustomAppConfig>({
  auth: {
    guestsLayouts: [],
    guestsPages: ['connexion-provider'],
    // eslint-disable-next-line ts/no-unused-vars
    impersonateRedirectionUrl: async (_id: number) => undefined,
    protectedLayouts: [],
    protectedPages: [],
    redirectToAfterLogin: () => '/',
    redirectToIfUnauthenticated: 'login',
    shouldRemainAuthFns: {},
  },
  theme: {
    dark: {
      logo: '/images/logo_light.svg',
    },
    light: {
      logo: '/images/logo_dark.svg',
    },
  },
  ui: {
    ...theme,
    colors: {
      purple: 'purple',
    },
  },
})
